<template>
  <EditorPopover ref="popover" @cancel="cancelEditing">

    <TabbedBox>
      <template v-slot:tablist>
        <Tab :first="true" tabid="tab-message">
          <i class="far fa-exclamation-triangle"></i> {{name}}
        </Tab>
      </template>

      <template v-slot:tabcontent>
        <TabPage :first="true" tabid="tab-message">
          <h4>{{title}}</h4>
          <span v-html="message" />

          <EditorPopoverButtonList v-if="editingEnabled">
            <EditorPopoverButton title="Close" type="cancel" icon="fa-times" @click="cancelEditing" />
            <EditorPopoverButton v-if="fixAvailable" title="Fix" type="action" icon="fa-magic" @click="fixClicked" />
          </EditorPopoverButtonList>
        </TabPage>
      </template>
    </TabbedBox>  
    
  </EditorPopover>
</template>



<script>
import _ from 'lodash'
import Utils from '@/utils/utils'
import EditorPopover from '@glass-designer/components/editorPopover'
import EditorPopoverMixin from '@glass-designer/mixins/editorPopover'
import EditorPopoverDataRow from '@glass-designer/components/editorPopoverDataRow'
import EditorKeypad from '@glass-designer/components/editorKeypad'
import MathsUtils from '@/utils/mathsUtils'

import EditorPopoverButtonList from '@glass-designer/components/popover/editorPopoverButtonList'
import EditorPopoverButton from '@glass-designer/components/popover/editorPopoverButton'

export default {
  name: 'EditorMessagePopover',
  mixins: [EditorPopoverMixin],
  components: {
    EditorPopover,
    EditorPopoverDataRow,
    EditorPopoverButtonList,
    EditorPopoverButton
  },
  props: {
    editingEnabled: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      toolInfoText: '',
      name: '',
      title: '',
      message: '',
      fixAvailable: false
    }
  },
  computed: {
  },
  watch: {
    
  },
  created() {

  },
  methods: {
    setup(editor, options) {
      this.clearOptions()

      this.name = options.name || 'Message'
      this.title = options.title || ''
      this.message = options.message || ''
      this.fixAvailable = !!options.fixAvailable

      // Setup callbacks next tick so they don't get called when resetting values
      this.callbackContext = options.context
      this.updateCallback = options.updateCallback
      this.actionCallback = options.actionCallback
      this.applyCallback = options.applyCallback
      this.cancelCallback = options.cancelCallback
    },
    clearOptions() {
      this.callbackContext = null
      this.updateCallback = null
      this.actionCallback = null
      this.applyCallback = null
      this.cancelCallback = null
    },
    displayToolPopover(containerEl, editor, displayOptions) {
      this.$refs.popover.displayToolPopover(containerEl, editor, displayOptions)
    },
    viewportUpdated(containerEl, editor) {
    },
    hide() {
      if(this.cancelCallback) {
        // Reset cancel CB so it only is called once when hiding popovers
        let cancelCB = this.cancelCallback
        this.cancelCallback = null

        cancelCB(this.callbackContext, false)
      }

      this.clearOptions()
      this.$refs.popover.hide()
    },
    cancelEditing() {
      if(this.cancelCallback)
        this.cancelCallback(this.callbackContext, true)

      this.clearOptions()
      this.hide()
    },
    onShortcutKey(code) {
      switch(code) {
        case 'Escape':
          this.cancelEditing()
          break
      }
    },
    fixClicked() {
      if(this.actionCallback) {
        this.actionCallback(this.callbackContext, 'fix')
      }
    }
  }
}
</script>